import styled from 'styled-components';

import { Button, Input, Modal } from 'antd';

import { COLORS } from 'constants/colors';
import { FONTS, FONTS_WEIGHT } from 'constants/fonts';

export const StyledModal = styled(Modal)`
  z-index: 1000 !important;
  .ant-modal-content {
    border-radius: 10px;
    padding: 20px;
  }

  .ant-modal-header {
    border-bottom: none;
    padding-bottom: 0;
  }

  .ant-modal-title {
          font-size: ${FONTS.SUB_HEADER_FONT};
    font-weight: ${FONTS_WEIGHT.TEXT_BOLD};
    line-height: 24px;
    color: ${COLORS.TextBase};
  }
.ant-modal {
    z-index: 1000 !important;
  }
  .ant-modal-body {
    padding-top: 10px;
  }
  width: 520px !important;
  min-height: 480px;
  max-height: 798px;
  }
`;

export const StyledSection = styled.div`
  display: flex;
  flex-direction: column;
  z-index: 50;
`;

export const StyledFormSection = styled(StyledSection)`
  margin-top: 24px;
`;

export const StyledDateFormSection = styled(StyledSection)`
  margin-top: 30px;
`;

export const StyledLocationFormSection = styled(StyledSection)`
  margin-top: 34px;
  margin-bottom: 24px;
`;

export const CustomTimeDropdown = styled.div`
  max-width: 100%;
  z-index: 1050;
`;

export const StyledSectionLabel = styled.label`
  margin-bottom: 6px;
  font-size: ${FONTS.TEXT_FONT};
  font-weight: ${FONTS_WEIGHT.TEXT_BOLD};
  line-height: 18px;
  color: ${COLORS.colorTextSecondary};
  text-transform: uppercase;
`;

export const StyledInput = styled(Input)`
  height: auto;
  resize: none;
  line-height: 22px;
  overflow: hidden;
    color: ${COLORS.TextBase};
        border-color: ${COLORS.Grey10};


  &::placeholder {
    font-size: ${FONTS.BASE_TEXT_FONT};
    font-weight: ${FONTS_WEIGHT.TEXT_REGULAR};
    line-height: 22px;
    color: ${COLORS.colorTextPlaceholder};
  }

  &:focus {
    outline: none;
    border: 1px solid ${COLORS.Grey10};
    box-shadow: none;
  }
  }
`;

export const SettingItem = styled.div`
  width: 187px;
  display: flex;
  &:not(:first-child) {
    padding-left: 41px;
  }
`;

export const StyledSpan = styled.span`
  padding-left: 8px;
  width: 135px;
`;

export const SettingsWrapper = styled.div`
  display: fixed;
  align-items: center;
  .ant-picker-dropdown {
    position: fixed !important;
  }

  Input {
    width: 277px;
    height: 32px;
  }

  &:last-child {
    margin-bottom: 0;
    margin-top: 0;
  }
`;

export const StyledTextArea = styled(Input.TextArea).attrs(() => ({
  autoSize: { minRows: 3 },
}))`
  height: auto;
  resize: none;
  line-height: 22px;
  overflow: hidden;
    color: ${COLORS.TextBase};
        border-color: ${COLORS.Grey10};
  &::placeholder {
      font-size: ${FONTS.BASE_TEXT_FONT};
    font-weight: ${FONTS_WEIGHT.TEXT_REGULAR};
    line-height: 22px;
    color: ${COLORS.colorTextPlaceholder};
  }

  &:focus {
    outline: none;
    border: 1px solid ${COLORS.Grey10};
    box-shadow: none;
  }
  }
`;

export const StyledFAddOptionButton = styled(Button)`
  display: flex;
  justify-content: center;
  background-color: ${COLORS.colorBgTextHover};
  font-size: ${FONTS.BASE_TEXT_FONT};
  font-weight: ${FONTS_WEIGHT.TEXT_BOLD};
  line-height: 22px;
  color: ${COLORS.TextBase};
`;
